export enum ContactGroupType {
  CUSTOMER = 'customer',
  VENDOR = 'vendor',
}
